import type { PropsWithChildren } from "react";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";

import SearchResultsTableFallback, { TableFallback } from "../SearchResultsTableFallback/SearchResultsTableFallback";

type Props = PropsWithChildren<{
    shouldSuspend: boolean;
}>;

const SearchResultsTableContainerBoundary = ({ shouldSuspend, children }: Props) => {
    return (
        <SearchResultsTableFallback isVisible={shouldSuspend}>
            <ErrorBoundaryWithLogging
                fallback={<TableFallback isLoading={false} />}
                resetKeys={[shouldSuspend]}
            >
                {children}
            </ErrorBoundaryWithLogging>
        </SearchResultsTableFallback>
    );
};

export default SearchResultsTableContainerBoundary;
